import { ThunkAction } from "redux-thunk";
import { RootState } from "slices";
import { Action, Dispatch } from "redux";
import { registerFailed, registerSuccess, resetRegister } from "./reducer";
import { postRegister } from "helpers/backend_helper";

interface User {
    email: string;
    username: string;
    password: string;
}

export const registerUser = (user: User
): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch) => {
    try {
        let response: any;
        if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        } else if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        }else if (process.env.REACT_APP_DEFAULTAUTH === "development") {
            response = await postRegister({
                userName: user.username,
                emailAddress: user.email,
                password: user.password,
                appName: 'Alle AI'
            });
        }
        if(response.error){
            dispatch(registerFailed(response.error.message));
            return ;
        }
        if (response) {
            dispatch(registerSuccess(response));
        }
    } catch (error: any) {
        dispatch(registerFailed(error));
    }
};

export const resetRegisterFlag = () => {
    try {
        const response = resetRegister(false);
        return response;
    } catch (error) {
        return error;
    }
};